import styled from "styled-components";
import { CMLegend } from "../../chart/chart.styles";

export const CMPrimaryCard = styled.div`
  padding: 3rem 1rem;
  display: flex;
  border-radius: 8px;
  position: relative;
  flex-direction: column;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;

  h4 {
    margin: 0;
    font-weight: 600;
    letter-spacing: -1.008px;
    font-family: Work Sans, sans-serif;
    font-size: clamp(1.375rem, 3vw, 1.75rem);

    & > span {
      font-weight: 500;
      letter-spacing: -0.45px;
      font-size: clamp(1.5rem, 3vw, 1.875rem);
    }
  }

  h6 {
    margin: 10px 0;
    font-weight: 500;
  }

  svg {
    margin: 0.26rem 0 0 0;
    width: 90px;
    height: 50px;
    padding-bottom: 15px;
  }

  @media ${(props) => props.theme.breakpoints.lg} {
    h4 {
      font-size: 28px;
    }
  }
  
  @media (max-width: 767px) {
    h4 {
      font-size: 24px;
    }
  }
`;

export const CMProgressCard = styled(CMPrimaryCard)`
  background-color: ${(props) => props.theme.palette.gray["500"]};

  a {
    padding: 5px 16px 5px 16px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    text-decoration-line: none;
    position: relative;
    @media (min-width: 2000px) {
        font-size: 3vh;
        width: 20vh !important;
        height: 4vh !important;
    }
  }
  a:hover {
    color: #a80000;
    border-color: #a80000;
    background-color: white;
  }
  h3 {
    @media (min-width: 2000px) {
        font-size: 2vh;
    }
  }
  h4 {
    @media (min-width: 2000px) {
        font-size: 4vh;
    }
  }
  span {
    @media (min-width: 2000px) {
        font-size: 3vh !important;
    }
  }
  svg {
    @media (min-width: 2000px) {
        width: 4vh !important;
        height: 4vh !important;
    }
  }
  
  @media (min-width: 2000px) {
  height: 30vh !important;
  justify-content:center
  } 
  @media ${(props) => props.theme.breakpoints.lg} {
    display: none;
  }
`;

export const CMUpcomingCard = styled(CMPrimaryCard)`
  padding: 1.5rem;
  background-color: white;
  text-align: center;

  & h4 {
    @media (min-width: 2000px) {
        font-size: 3vh;
        margin-top: 2vh;
    }
  }

  & > div h4 {
    margin: 0 0 1.25rem;
    font-weight: 500;
    font-size: 1.25rem;
    color: ${(props) => props.theme.palette.dark["900"]};
    @media (min-width: 2000px) {
        font-size: 3vh;
    }
  }

  &  h4 > span {
    @media (min-width: 2000px) {
        font-size: 3vh;
    }
  }

  & svg {
    margin-top: 0;
    margin-bottom: 1rem;
    @media (min-width: 2000px) {
        font-size: 3vh;
        width: 20vh !important;
        height: 4vh !important;
    }
  }

  a {
    @media (min-width: 2000px) {
        font-size: 3vh;
        width: 20vh !important;
        height: 4vh !important;
    }
  }
  
  @media (min-width: 2000px) {
        height: 30vh !important;
  }

  @media ${(props) => props.theme.breakpoints.lg} {
    display: none;
    text-align: left;
    align-items: flex-start;

    & > div {
      width: 100%;
      display: flex;
      justify-content: space-between;

      a {
        width: 130px;
        height: auto;
        height: fit-content;
        font-size: 19px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    & h6 {
      margin: 0;
    }
  }

  @media ${(props) => props.theme.breakpoints.xs} {
    padding: 1.5rem 0;
    text-align: center;
    align-items: center;

    & > div {
      flex-direction: column;

      a {
        margin: auto;
      }
    }
  }
`;

export const CMMobileCard = styled(CMPrimaryCard)`
  width: 100%;
  padding: 0;
  background-color: unset;
  box-shadow: unset;
  display: none;
  margin-bottom: ${(props) => props.theme.spacers["6"]};

  & svg {
    margin-top: 0;
  }

  & div.swiper {
    width: 38%;
    width: 300px;
    padding-bottom: 0;
  }

  @media ${(props) => props.theme.breakpoints.lg} {
    display: flex;
    & .responsiveSpotify {
      flex-direction: row;
    }

    & div.swiper {
      width: 280px;
    }
  }
`;

export const CMDetailsCard = styled(CMPrimaryCard)((props) => ({
  padding: "4rem 10px 0",
  position: "relative",
  borderTop: `solid 1px ${props.theme.palette.gray["700"]}`,
  backgroundColor: props.theme.palette.gray["500"],

  "& h3": {
    margin: 0,
    fontSize: 28,
    fontWeight: 600,
    textAlign: "center",
    fontFamily: props.theme.fontFamilies.workSans,

    "& span": {
      fontWeight: 500,
      fontSize: 30,
      fontFamily: props.theme.fontFamilies.workSans,
    },
  },

  "& .details": {
    width: "100%",

    "& .bidding-details": {
      padding: "1px 1rem 1px 1.5rem",
      position: "absolute",
      top: "15px",
      right: 0,
      borderTopRightRadius: "15px",
      borderBottomRightRadius: "15px",
      textDecorationLine: "underline",
      border: "unset !important",
      [`@media${props.theme.breakpoints.lg}`]: {
        padding: 0,
        marginTop: 65,
        right: "42.5%"
      },
      [`@media${props.theme.breakpoints.sm}`]: {
        right: 0,
        paddingRight: "1rem"
      }
    },

    [`@media (min-width: 2000px)`]: {
      margin:"auto"
    },

    [`@media${props.theme.breakpoints.xs}`]: {
      "& .live-title":{
        fontSize:"18px"
      },
    },

  },
  

  [`${CMLiveTag}`]: {
    top: 30,
  },

  [`@media (min-width: 2000px)`]: {
    margin:"auto",
    minHeight:"30vh",
    height:"100%",
    "& h3": {
      fontSize: '3.5vh'
    },
    "& h3 span": {
      fontSize: '3.5vh'
    },
    '& button': {
     fontSize: '1.8vh',
     marginRight:"2vh"
    },
  },

  [`@media${props.theme.breakpoints.lg}`]: {
    "& .details": {
      marginTop: "50px",
    },
  },
}));

export const CMUpcomingDetailsCard = styled(CMDetailsCard)((props) => ({

  "& .details": {
    textAlign: "center",

    "& h5": {
      fontSize: "20px",
      fontFamily: props.theme.fontFamilies.workSans,
      [`@media (min-width: 2000px)`]: {
        fontSize: "1.8vh",
      },
    },
    "& p": {
      [`@media (min-width: 2000px)`]: {
        fontSize: "1.8vh",
      },
    },
    "& button": {
      [`@media (min-width: 2000px)`]: {
        fontSize: "3vh !Important",
      },
    },

    "& .metrics-container": {
      height: "170px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      backgroundColor: "white",
      marginTop: "40px",

      [`@media (min-width: 2000px)`]: {
        height: "80%",
      },

      "& > div": {
        marginTop: "-40px",
        "& a": {
          width: "60%",
          fontSize: props.theme.fontSizes.h3,
        },
      },
    },
  },
  [`@media${props.theme.breakpoints.lg}`]: {
    "& .MetricsDetailResponsive": {
      flexDirection: "row",
      justifyContent: "center",
    },
  },
}));

export const CMTradeCard = styled(CMPrimaryCard)((props) => ({
  padding: "1rem 10px 0",
  position: "relative",
  borderTop: `solid 1px ${props.theme.palette.gray["700"]}`,
  backgroundColor: props.theme.palette.gray["500"],

  "& .tradeButton": {
    height: 34,
    minWidth: 120,
    fontWeight: 500,
    fontSize: props.theme.fontSizes.h4,
    marginTop: -40,
    borderRadius: 32,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  "& .details": {
    width: "100%",
  },

  "& > a": {},

  [`@media${props.theme.breakpoints.sm}`]: {
    "& .tradeButton": {
      padding: "5px 10px",
    },

    "& .profits": {
      marginLeft: "0 !important",
    },
  },
  [`@media (max-width: 768px)`]: {
    height:'100%',
   left:'50%',
   width:'97vw',
   transform: 'translateX(-50%)',
    "& .tradeButton": {
      padding: "5px 10px",
    },
    "& .profits": {
      marginLeft: "0 !important",
    },
  },
  [`@media (max-width: 480px)`]: {
    height:'100%',
   left:'50%',
   width:'94vw',
   transform: 'translateX(-50%)',
    "& .tradeButton": {
      padding: "5px 10px",
    },
    "& .profits": {
      marginLeft: "0 !important",
    },
  },
  
  
}));


export const CMImage = styled.div((props) => ({
  width: "fit-content",
  top: "-50px",
  display: "flex",
  padding: "1rem 6px",
  borderRadius: "50%",
  position: "absolute",
  alignItems: "center",
  justifyContent: "center",
  borderTop: `solid 2px ${props.theme.palette.gray["700"]}`,
  backgroundColor: props.theme.palette.gray["500"],

  "&.upcoming-auction": {
    padding: "0.2rem 2rem",
  },

  "& img": {
    width: "75%",
  },


  "& svg": {
    [`@media (min-width: 2000px)`]: {
     display:"none"
    },
  },

  [`@media (min-width: 2000px)`]: {
    display:"none"
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    top: "15px",

    width: 70,
    padding: 0,
    border: "none",

    "& img": {
      width: "100%",
    },
  },

  [`@media ${props.theme.breakpoints.xs}`]: {
    width: 60,
    marginRight:"30px"
  },
}));

export const CMDetailsContainer = styled.div((props) => ({
  display: "flex",
  flexDirection: "column",
  backgroundDolor: "white",
  borderRadius: "12px",
  marginTop: "3rem",

  "& .details-auction-metrics": {
    width:"100%",
    paddingBottom: 20,
    justifyContent: "center",
    textAlign:"center",

    "& > div": {
      margin: "0 8px",
      width:"100%",
      justifyContent: "center",
    },

    "& svg": {
      paddingBottom: 0,
    },
  },

  "& > div": {
    width: "auto",
    position: "relative",
    display: "flex",
    marginBottom: 0,
    justifyContent: "center",
    flexDirection: "column",

    "& > div > div": {
      width: "100%",
      margin: "auto",

      "& > div": {
        width: "50%",
        margin: "0.5rem auto 1rem",
        [`@media (min-width: 2000px)`]: {
          width: "80%",
        },

        "& > p": {
          color: "black",
          fontWeight: 500,
          textAlign:"center",
          "& > span": {
            color: "rgb(116, 201, 50)",
            fontWeight: 500,
          },
          [`@media (min-width: 2000px)`]: {
            fontSize: "2vh",
          },
        },

        [`@media ${props.theme.breakpoints.xs}`]: {
         "& > p": {
          fontSize:"0.8rem",
          "& > span": {
          fontSize:"0.8rem",
          },
        },
        },

      },
    },

    "& > button": {
      fontWeight: 500,
      width: "70%",
      padding: "5px 1rem",
      top: "-12px",
      margin: 0,
      position: "absolute",
      left: "50%",
      transform: "translate(-50%, 0)",
      fontSize: 28,
      textTransform: "unset",
      border: `solid 1px ${props.theme.palette.gray["700"]}`,
      backgroundColor: props.theme.palette.green["700"],
      borderRadius: "30px",
      color: "#fff",
      boxShadow:
        "rgba(0, 0, 0, 0.1) 0px 5px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",

      "&:hover": {
        color: "white",
        borderColor: props.theme.palette.green["900"],
        backgroundColor: props.theme.palette.green["900"],
      },
    },

    "& > div": {
      marginTop: "1rem",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "white",
      paddingTop: "30px",

      "& > .red-label": {
        color: props.theme.palette.primary.main,
      },

      "& > span": {
        fontSize: 18,
      },

      "& > button": {
        textAlign: "left",
        textDecoration: "underline",
      },
      [`@media (min-width: 2000px)`]: {
        marginTop: "5vh",
        //backgroundColor:"transparent",
       },
    },
  },

  [`@media (min-width: 2000px)`]: {
   "& button":{
    fontSize:"3vh !important"
   }
  },

  [`@media${props.theme.breakpoints.xs}`]: {
    "& > div": {
      width: "100%",

      "& > button": {
        padding: "5px 0",
        fontSize: 22,
      },
    },
  },
}));

export const CMLiveTag = styled.span`
  background-color: ${(props) => props.theme.palette.primary["500"]};
  color: white;
  padding: 1px 1rem 1px 1.5rem;
  position: absolute;
  top: 15px;
  left: 0;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  @media (min-width: 2000px) {
    font-size: 2vh !important;
  }
`;

export const CMIncrease = styled.img`
  color: white;
  padding: 1px 1rem 1px 1.5rem;
  position: absolute;
  top: 20px;
  right: 0;
  font-size:25px;
  width:25px;
  height:25px;
`;

export const CMTradeDetails = styled.div((props) => ({
  padding: "1rem 2rem 0",
  backgroundColor: "white",

  "& > h5": {
    margin: 0,
    fontWeight: 500,
    fontSize: 24,
    fontFamily: props.theme.fontFamilies.workSans,
  },

  "& > div": {
    justifyContent: "center",
  },

  [`& ${CMLegend}`]: {
    marginTop: props.theme.spacers["7"],
    fontSize: props.theme.fontSizes.caption,
  },

  [`@media ${props.theme.breakpoints.xss}`]: {       
    padding: 0,
  }

}));

export const CMCurrentPrice = styled.div((props) => ({
  display: "flex",
  padding: "3% 10% 5%",
  fontWeight: 300,
  gap: "20%",
  alignItems: "center",
  marginTop: "5%",

  "& .current-price-trade": {
    margin: 0,
    marginBottom: "-5px",
    "& p": {
      fontSize:"42px"
  },
  },

  "& .advance-trade-link": {
    position:"absolute",
    right:"5%",
    top:"5%"
  },

  "& p": {
    margin: 0,
    marginBottom: "-5px",
  },

  "& .current-price": {
    fontSize: props.theme.fontSizes.h1,
  },

  "& .profits": {
    '& h6':{
          display: "none"
        }
  },
  "& .profits > div": {
    display: "flex",
    alignItems: "center",
    //marginLeft: "10%",    
    gap: 0,    

    "& svg": {
      width: "32px",
      height: "32px",
      margin: "0",
      transform: "rotate(-45deg)",
    },

    "& p": {
      fontWeight: 300,
      color: props.theme.palette.green["800"],
      fontSize: 28,
    },
  },
}));

export const LoadContent = styled.div((props) => ({
  width:"100%",
  minHeight:"114px",
  '& svg':{
    margin: "0 !important",
    width: "auto !important",
    height: "auto !important",
    paddingBottom: "0 !important",
  }

}));

export const TransactionContend = styled.button((props) => ({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& > img': {
      width: '12px',
      height: '12px',
      marginTop: '-10px',
      filter: 'invert(46%) sepia(83%) saturate(449%) hue-rotate(86deg) brightness(92%) contrast(89%)',
  },
}));


export const ModalContent = styled.div((props) => ({
  padding: "20px",
  backgroundColor: "white",
  borderRadius: "20px",
  maxWidth: "400px",
  width: "100%",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  zIndex: "99999",

  "& .close_button":{
    background: 'none',
    border: 'none',
    color: 'gray',
    fontSize: '2rem',
    cursor: 'pointer',
    width:"auto",
    height:"auto",
    "& span": {
      [`@media (min-width: 2000px)`]: {
        fontSize: "3vh",
      },
    }
  },

  [`@media (min-width: 2000px)`]: {
    maxWidth: "20%",
    height:"auto",
    "& h3": {
      fontSize: "3.5vh",
    },
    "& p": {
      fontSize: "3.5vh",
    },
    "& span": {
      fontSize: "2.5vh",
    },
    "& button": {
      fontSize: "3vh",
      width:"100%",
      height:"5vh",    
    },
    "& label span svg": {
      width:"3vh",
      height:"3vh", 
    },
  },


}));